/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-28 14:44:51
 * @LastEditors: liuziwei
 * @Description: 首页 - 大按钮 - 气泡
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view wx:if="{{bubbleText}}" class="bubble-button-container">
    <!-- 按钮 - 叠在上边展示给用户的 -->
    <view class="before-button bubble-button">
      {{ bubbleText }}
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      bubbleText: {
        type: String,
        value: () => ''
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .bubble-button-container
    position relative
    .bubble-button
      width 100%
      height 100%
      padding 2px 9px
      box-sizing border-box
      border-radius 11px 11px 0 11px
      border 1px solid #ffffff

    .before-button
      position relative
      z-index 2
      background linear-gradient(179deg, #FFECAB 3%, #FFF6DD 151%)
      display flex
      justify-content center
      align-items center
      font-family PingFang SC
      font-size 11px
      font-weight 500
      color #FF5900
</style>

<script name='json'>
  module.exports = {
    usingComponents: {}
  }
</script>
